







import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import { anchorKinds, getSelectedLangName } from '@/heplers';
import DocIcon from '@/components/ui/icons/DocIcon.vue';
import GlobalBus from '@/plugins/GlobalBus';
import { KindMethodKeys } from '@/templates/NewRoutes';
import { LanguagesPack, SelectedLanguagesPack } from '@/store/types';
import { referencesMethod } from '@/templates/References';
import { parseAdvancedHrefHelper, parseHrefHelper } from '@/heplers/stringHelpers';
import { GlobalBusNames } from '@/templates/DataNames';

interface grpcObject {
  [grpc: string]: string;
}

@Component({
  components: {
    DocIcon,
  },
  filters: {
    parseHref: parseHrefHelper,
  },
})
export default class LegendOptions extends Vue {
  @Prop(Object) method: referencesMethod;
  @Getter('getSelectedLanguagesPack') languagesPack: SelectedLanguagesPack;

  get currentLanguage() {
    return this.languagesPack[<keyof LanguagesPack>getSelectedLangName(this.$route.meta.fqdn)];
  }

  get checkAllowedForCurrentLanguage() {
    if (this.method.attributes && this.method.attributes[this.currentLanguage] === false) {
      return false;
    }
    return true;
  }

  getTitle(title: string | grpcObject) {
    if (typeof title == 'object' && title.grpc) {
      return title.grpc;
    } else return title;
  }

  parseHrefByKind(fqdn: string, kind: any) {
    return parseAdvancedHrefHelper(fqdn, kind);
  }

  computeMethodHref() {
    return !this.checkAnchorKind(this.method.kind)
      ? this.goToLink(this.method.fqdn)
      : this.bindScroll(this.method.fqdn);
  }

  dataKindIcon(kind: string) {
    let dataKinds: string[] = Object.values(KindMethodKeys);
    return dataKinds.includes(kind);
  }

  goToLink(fqdn: string) {
    this.$router
      .push(parseHrefHelper(fqdn))
      .then(() => GlobalBus.emit('openLink', fqdn.split('.')));
  }

  bindScroll(fqdn: string) {
    GlobalBus.emit(GlobalBusNames.LEGENDOPTIONSSCROLL, fqdn);
  }

  checkAnchorKind(kind: string) {
    return anchorKinds.includes(kind);
  }
}
